'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.takeLatest = takeLatest;

var _effects = require('redux-saga/effects');

var effects = _interopRequireWildcard(_effects);

var _transform = require('./transform');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function takeLatest(pattern, worker) {
    return effects.takeLatest((0, _transform.transform)(pattern), worker);
}
//# sourceMappingURL=takeLatest.js.map


// WEBPACK FOOTER //
// ./node_modules/@zaibot/fsa-saga/es5/takeLatest.js